// YouTube embed URLs, native-aware.
// In the Capacitor app (capacitor://localhost) YouTube rejects the Referer and
// every embed fails with error 153, so native routes through the hosted shim
// page (public/yt-embed.html on the prod web origin). Web embeds directly.

const SHIM_ORIGIN = 'https://dspcafe.vercel.app';

const isNative = () => window.location.protocol === 'capacitor:';

export function youtubeEmbedSrc(youtubeId, { autoplay = true } = {}) {
  const auto = autoplay ? '1' : '0';
  if (isNative()) {
    return `${SHIM_ORIGIN}/yt-embed.html?v=${encodeURIComponent(youtubeId)}&autoplay=${auto}`;
  }
  return `https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=${auto}&rel=0&playsinline=1`;
}
